import apiHelpers from './apiHelpers.js';
import { mapCrudStoreGen } from '@/helpers/utils/storeHelpers.js';

let defaultForm = {
  type: 0,
  customReferenceNumber: '',
  userNote: '',
  shippings: [],
  projectId: '',
  brandId: null,
  vendorId: null,
  orderNumber: '',
  expectedDate: '',
  shippingFee: 0,
  otherFees: 0,
  orderStatus: 0,
  items: []
};

let defaultFilters = {
  brandId: '',
  isDue: '',
  customerRequested: false,
  orderStatus: 'Non-Archived',
  itemSKU: '',
  orderNumber: '',
  type: 1
};

let genedStore = mapCrudStoreGen(defaultForm, defaultFilters, apiHelpers);

export default {
  namespaced: true,

  state: () => ({
    ...genedStore.state,
    recommendedForm: null
  }),

  mutations: {
    ...genedStore.mutations,
    setRecommendedForm(state, payload) {
      state.recommendedForm = payload;
    }
  },

  getters: {
    ...genedStore.getters,
    getRecommendedForm: state => {
      return state.recommendedForm;
    }
  },

  actions: {
    ...genedStore.actions
  },
};
